
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import useTranslation from "next-translate/useTranslation";
import Link from "next/link";
import { useRouter } from "next/router";
import { useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Card, CardBody, CardText, Col, Row } from "reactstrap";
import { AnyAction, Dispatch } from "redux";
import { IUser } from "@api/schema";
import BaseLayout from "@components/BaseLayout";
import TranslatedHtml from "@components/common/TranslatedHtml";
import RegistrationForm from "@components/user/RegistrationForm";
import { registerUserAction } from "@redux/actions/registration";
import { IFormikActions } from "@redux/helper/actions";
import { AppState } from "@redux/reducer";
import { selectIsAuthenticated } from "@redux/reducer/auth";
import { Routes } from "@services/routes";
const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
    registerUser: (user: IUser, actions: IFormikActions) => dispatch(registerUserAction(user, actions)),
});
const mapStateToProps = (state: AppState) => ({
    isAuthenticated: selectIsAuthenticated(state),
});
const connector = connect(mapStateToProps, mapDispatchToProps);
type PageProps = ConnectedProps<typeof connector>;
/**
 * This page allows the user to register as a user of the platform.
 */
const RegistrationPage: React.FC<PageProps> = (props: PageProps) => {
    const { isAuthenticated, registerUser } = props;
    const { t } = useTranslation("common");
    const [registered, setRegistered] = useState(false);
    const router = useRouter();
    if (isAuthenticated) {
        void router.push(Routes.UserProfile);
        return null;
    }
    const onSubmit = (user: IUser, actions: IFormikActions): void => {
        actions.onSuccess = () => {
            setRegistered(true);
        };
        registerUser(user, actions);
    };
    return <BaseLayout pageTitle={t("page.user.register.title")}>
    <Row>
      <Col>
        <h1>{t("page.user.register.heading")}</h1>
        <p><TranslatedHtml content="page.user.register.intro"/></p>
      </Col>
    </Row>
    <Row>
      <Col sm={8}>
        <Card>
          <CardBody>
            {!registered && <>
              <RegistrationForm onSubmit={onSubmit}/>
            </>}

            {registered && <>
              <CardText className="text-success">
                <TranslatedHtml content="page.user.register.userCreated"/>
              </CardText>
              <CardText className="text-center">
                <Link href={Routes.Login}>
                  <a className="btn primary-btn">{t("goto.login")}</a>
                </Link>
              </CardText>
            </>}
          </CardBody>
        </Card>
      </Col>
    </Row>
  </BaseLayout>;
};
const __Next_Translate__Page__18c4f517d21__ = connector(RegistrationPage);

    export default __appWithI18n(__Next_Translate__Page__18c4f517d21__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
    });
  